import { Component, Input, OnInit } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-next-step-card',
  templateUrl: './next-step-card.component.html',
  styleUrls: ['./next-step-card.component.scss'],
})
export class NextStepCardComponent implements OnInit {
  @Input() title?: string;
  @Input() text?: string;
  @Input() secondaryText?: string;
  @Input() link?: string;
  @Input() linkRedirect?: string;
  @Input() button?: string;
  @Input() variant?: string;
  @Input() imgSrc?: string;

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;
  constructor(private _router: Router) {}

  loginRedirect() {
    this._router.navigate(['/login-register']);
  }
  ngOnInit(): void {}
}
